// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb_root_Z9cAq","arrow":"Breadcrumb_arrow_Q8GYt"};